export const HIDE_PAYMENTS_MODAL: string = 'hide-payments-modal';
